export const SET_DISPATCH_NOTIFICATION_ITEMS ='SET_DISPATCH_NOTIFICATION_ITEMS';
export const UPDATE_DISPATCH_NOTIFICATION_ITEMS = 'UPDATE_DISPATCH_NOTIFICATION_ITEMS'
export const DELETE_DISPATCH_NOTIFICATION_PRODUCT_IN_LIST='DELETE_DISPATCH_NOTIFICATION_PRODUCT_IN_LIST'
export const CLEAR_DISPATCH_NOTIFICATIONS_ITEMS ='CLEAR_DISPATCH_NOTIFICATIONS_ITEMS';
export const SET_VENDOR_DATA = 'SET_VENDOR_DATA';
export const ADD_NEW_DISPATCH_ITEM= 'ADD_NEW_DISPATCH_ITEM';
